<template>
	<el-dialog title="消息通知" :visible="show" width="400px" @close="closeDialog">
		<div class="message-dialog">
			<div class="label" style="font-size: 18px;margin-bottom: 20px">
				<span>{{ row.nickname }} </span>
				<span>{{ row.title }} </span>
				<span :style="{color:statusInfo.color}">{{statusInfo.text}}</span>
			</div>
			<div class="content v-ellipsis-4">{{ row.content }}</div>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="closeDialog" size="small">知道了</el-button>
			<el-button type="primary" size="small" @click="showMessageList()">去看看</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import polylineInfo from '@/pages/preview/polyline'
	export default {
		props:{
			show:Boolean,
			row:Object
		},

		computed:{
			statusInfo(){
				return polylineInfo[this.row.msg_data.status]
			},
		},

		methods:{
			closeDialog(){
				this.$emit('update:show',false);
			},
			showMessageList(){
				this.closeDialog();
				this.$emit('show-message');
			}
		}
	}
</script>